import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-projet-professionnel-jobs-card',
  templateUrl: './projet-professionnel-jobs-card.component.html',
  styleUrls: ['./projet-professionnel-jobs-card.component.scss']
})
export class ProjetProfessionnelJobsCardComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
